export enum CourseState {
    unknown = 0,
    draft = 1,
    active = 2,
    inActive = 3,
    bounced = 4,
    archive = 5,
    inAppPreview = 6,
    pendingQa = 7
}